import React from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import TX from '@Components/Common/Text';

import PrevIconSVG from '@Assets/Svgs/ic_prev.svg';
import SettingIconSVG from '@Assets/Svgs/ic_setting.svg';
import DividerSVG from '@Assets/Svgs/divider_0.5_vert.svg';

const ProjectTitle = ({ title, projectId }) => {
  const navigate = useNavigate();

  const handleGoBackMoveClick = () => navigate(-1);

  const handleProjectSettingMoveClick = () =>
    navigate({
      pathname: '/project_setting',
      search: `${createSearchParams({
        id: `${projectId}`,
      }).toString()}`,
    });

  return (
    <ProjectTitleContainer>
      <ToPrevContainer onClick={handleGoBackMoveClick}>
        <PrevIconWrapper>
          <PrevIcon />
        </PrevIconWrapper>
        <TitleWrapper>
          <ProjectTitleText>{title}</ProjectTitleText>
        </TitleWrapper>
      </ToPrevContainer>
      <Divider />
      <ProjectSettingIconWrapper onClick={handleProjectSettingMoveClick}>
        <ProjectSettingIcon />
      </ProjectSettingIconWrapper>
    </ProjectTitleContainer>
  );
};

ProjectTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FlexAlignStartDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const ProjectTitleContainer = styled(FlexAlignStartDiv)`
  width: 100%;

  border: 1px solid ${({ theme }) => theme.colors.ui_4};
  box-sizing: border-box;
  border-radius: 6px;
  height: 32px;
  position: relative;
`;

const ToPrevContainer = styled(FlexAlignStartDiv)`
  height: 32px;
  position: absolute;
  top: 0;
  right: 32px;
  left: 0;
  cursor: pointer;
`;

const Divider = styled.img.attrs({ src: DividerSVG })`
  height: 24px;
  top: 8;
  width: 2px;
  right: 34px;
  position: absolute;
`;

const TitleWrapper = styled.div`
  padding: 4px;
  width: calc(100% - 40px);
  white-space: nowrap;
  display: flex;
  align-items: left;
  justify-content: left;
`;

const ProjectTitleText = styled(TX.Caption1)`
  flex: 1;
  max-width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PrevIconWrapper = styled(FlexAlignCenterDiv)`
  width: 32px;
  height: 32px;

  cursor: pointer;
`;

const PrevIcon = styled.img.attrs({ src: PrevIconSVG, alt: '이전으로' })`
  width: 16px;
  height: 16px;
`;

const ProjectSettingIconWrapper = styled(FlexAlignCenterDiv)`
  width: 32px;
  height: 32px;
  right: 1px !important;
  position: absolute !important;
  top: -1 !important;
  cursor: pointer;
`;

const ProjectSettingIcon = styled.img.attrs({ src: SettingIconSVG, alt: '프로젝트 설정' })`
  width: 16px;
  height: 16px;
`;

export default React.memo(ProjectTitle);
